import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 0C6.77614 0 7 0.223858 7 0.5V6.00098H12.5361C12.7924 6.0012 13 6.20857 13 6.46484C13 6.72112 12.7924 6.92848 12.5361 6.92871H7V12.5C7 12.7761 6.77614 13 6.5 13C6.22386 13 6 12.7761 6 12.5V6.92871H0.463867C0.207642 6.92848 2.15248e-07 6.72112 0 6.46484C1.12023e-08 6.20857 0.207642 6.0012 0.463867 6.00098H6V0.5C6 0.223858 6.22386 0 6.5 0Z",
		fill: "black"
	})
});
export default SvgPlus;
